import { Checkbox, Collapse, Radio, Stack, Text, Textarea } from '@mantine/core';
import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';

import { useWidgetFormContext } from '@/components/Widget/Embed/form-context';
import { useWidgetForm } from '@/hooks/useWidgetForm';
import { useCanAccess } from '@mygpt/app';
export const WelcomeMessage = ({ chatbotCollapseOpened }: { chatbotCollapseOpened: boolean }) => {
  const { t } = useTranslation();
  const { form } = useWidgetFormContext();
  const { onOverrideChangeForForm } = useWidgetForm();
  const canAccessWidgetCustomization = useCanAccess('enable_widget_customization');

  const singleLanguageOpened = useMemo(() => {
    return form.values.chatbot.welcomeMessage.checked && form.values.chatbot.welcomeMessage.type === 'singleLanguage';
  }, [form.values.chatbot.welcomeMessage.checked, form.values.chatbot.welcomeMessage.type]);

  const multiLanguageOpened = useMemo(() => {
    return form.values.chatbot.welcomeMessage.checked && form.values.chatbot.welcomeMessage.type === 'multiLanguage';
  }, [form.values.chatbot.welcomeMessage.checked, form.values.chatbot.welcomeMessage.type]);

  return (
    <Stack>
      <Checkbox
        disabled={!canAccessWidgetCustomization}
        label={<Text>{t('widget.setting.chatbot.welcome_message_label')}</Text>}
        description={t('widget.setting.chatbot.welcome_message_desc')}
        checked={form.values.chatbot.welcomeMessage.checked}
        {...form.getInputProps('chatbot.welcomeMessage.checked')}
        onChange={onOverrideChangeForForm('chatbot.welcomeMessage.checked')}
      />
      <Radio.Group
        {...form.getInputProps('chatbot.welcomeMessage.type')}
        onChange={onOverrideChangeForForm('chatbot.welcomeMessage.type')}
      >
        <section className="border rounded-lg p-3 mb-2">
          <Radio
            size="xs"
            label={t('widget.setting.chatbot.welcome_message_label_single')}
            value="singleLanguage"
            disabled={!form.values.chatbot.welcomeMessage.checked}
          />
          <Collapse in={chatbotCollapseOpened && singleLanguageOpened}>
            <Textarea
              className="mt-4"
              disabled={!form.values.chatbot.welcomeMessage.checked}
              autosize
              minRows={3}
              {...form.getInputProps('chatbot.welcomeMessage.value')}
              onBlur={onOverrideChangeForForm('chatbot.welcomeMessage.value')}
            />
          </Collapse>
        </section>
        <section className="border rounded-lg p-3">
          <Radio
            size="xs"
            label={t('widget.setting.chatbot.welcome_message_label_multi')}
            value="multiLanguage"
            disabled={!form.values.chatbot.welcomeMessage.checked}
          />
          <Collapse in={chatbotCollapseOpened && multiLanguageOpened}>
            <Stack className="mt-4" gap="sm">
              <Textarea
                label={<Text size="xs">中文</Text>}
                disabled={!form.values.chatbot.welcomeMessage.checked}
                autosize
                minRows={2}
                {...form.getInputProps('chatbot.welcomeMessage.multiLanguageValues.zh')}
                onBlur={onOverrideChangeForForm('chatbot.welcomeMessage.multiLanguageValues.zh')}
              />
              <Textarea
                label={<Text size="xs">English</Text>}
                disabled={!form.values.chatbot.welcomeMessage.checked}
                autosize
                minRows={2}
                {...form.getInputProps('chatbot.welcomeMessage.multiLanguageValues.en')}
                onBlur={onOverrideChangeForForm('chatbot.welcomeMessage.multiLanguageValues.en')}
              />
              <Textarea
                label={<Text size="xs">日本語</Text>}
                disabled={!form.values.chatbot.welcomeMessage.checked}
                autosize
                minRows={2}
                {...form.getInputProps('chatbot.welcomeMessage.multiLanguageValues.ja')}
                onBlur={onOverrideChangeForForm('chatbot.welcomeMessage.multiLanguageValues.ja')}
              />
              <Textarea
                label={<Text size="xs">한국어</Text>}
                disabled={!form.values.chatbot.welcomeMessage.checked}
                autosize
                minRows={2}
                {...form.getInputProps('chatbot.welcomeMessage.multiLanguageValues.ko')}
                onBlur={onOverrideChangeForForm('chatbot.welcomeMessage.multiLanguageValues.ko')}
              />
            </Stack>
          </Collapse>
        </section>
      </Radio.Group>
    </Stack>
  );
};
